import React from "react";
import { Box, List, ListItem, Paper } from "@mui/material";

import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';

import Footer from "components/Content/Footer/Footer";

import notes from 'app/releasenotes.json';

export default function ReleaseNotes() {
    return (
        <Box width="100%">
            <Box 
                style={{
                    height: "calc(100vh - 24px)",
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    overflowY: "scroll",
                }}
            >
                <Box>
                    <Box component="h2" sx={{ textAlign: "center", marginBottom: "25px" }}>
                        Release Notes
                    </Box>
                    {notes.releases.map(n =>
                        <Paper elevation={3} sx={{ padding: "15px", marginBottom: "55px", width: "900px" }}>
                            <Box component="h3">{n.version}</Box>
                            <Box component="h5">
                                <CalendarMonthOutlinedIcon color="primary" className="me-2" />
                                {n.releaseDate}
                            </Box>
                            <Box component="h6">{n.heading}</Box>
                            <Box>
                                <List sx={{
                                    listStyleType: 'disc',
                                    pl: 2,
                                    '& .MuiListItem-root': {
                                        display: 'list-item',
                                    },
                                }}
                                >
                                    {n.notes.map(x => <ListItem>{x}</ListItem>)}
                                </List>
                            </Box>
                        </Paper>
                    )}
                </Box>
            </Box>

            <Footer />
        </Box>
    );
}